/*
 * Login Javascript
 *
 * All of your custom javascript can be placed below, remember to seperate your functionality into seperate files.
 * Do NOT forgot to add comments above the different functions or functionalities that need explaining.
 * 
 */
var components = './components/';

// Load all components below, for example:
// require(components + 'prepare-for-ajax');


// WEBPACK FOOTER //
// ./vendor/click/clickadmin/src/resources/assets/js/login/app.js